import { Box, DashboardModule, Text } from '@domain-group/suit-theme'

import PublicationEditionHeader from '@components/PublicationEditionHeader'

import { formatEntityCount } from '@functions/entity'

import usePublicationEdition from '@hooks/usePublicationEdition'

import AgencyGroup from './AgencyGroup'

interface PublicationEditionGroupProps {
  editionAgencies: object,
  orderCount: number,
  publicationEditionId: number,
}

const PublicationEditionGroup = (props: PublicationEditionGroupProps) => {
  const { editionAgencies, orderCount, publicationEditionId } = props

  const { publication, publicationEdition } = usePublicationEdition({ id: publicationEditionId })

  const secondaryText = formatEntityCount({ entityString: 'Order', entityCount: orderCount })

  return (
    <DashboardModule
      customHeader={(
        <PublicationEditionHeader
          publicationEdition={publicationEdition}
          // @ts-expect-error TS2339
          publicationTitle={publication.title}
        >
          <Text color="faintGrey" fontSize="xsmall">{secondaryText}</Text>
        </PublicationEditionHeader>
      )}
    >
      <Box flexDirection="column">
        {Object.values(editionAgencies).map((editionAgency, i, arr) => (
          <AgencyGroup
            editionAgency={editionAgency}
            isLastGroup={arr.length - 1 === i}
            key={editionAgency.id}
          />
        ))}
      </Box>
    </DashboardModule>
  )
}

export default PublicationEditionGroup
